import React, { Fragment } from 'react';
import MultiSelectInput from './../../se/components/inputs/MultiSelectInput';

export type AnalyticsPdfOption = { value: string; label: string };

export const analyticsPdfV1Option: AnalyticsPdfOption = {
  label: 'Analytics Pdf v1',
  value: 'Analytics Pdf v1',
};

export const detailedReportPdfOption: AnalyticsPdfOption = {
  label: 'Detailed Report',
  value: '',
};

export const defaultAnalyticsPdfOption = analyticsPdfV1Option;

export const analyticsPdfsOptions = [
  analyticsPdfV1Option,
  {
    label: 'Analytics Pdf v2',
    value: 'Analytics Pdf v2',
  },
  {
    label: 'Analytics Pdf v3',
    value: 'Analytics Pdf v3',
  },
  detailedReportPdfOption,
  { label: 'CPT Analytics', value: 'OASC' },
  { label: 'Operations Analytics', value: 'NASC' },
  { label: 'Specialty Analytics', value: 'HSS' },
];

const AnalyticsPdfsMultipleSelectInput = ({
  value,
  onChange,
}: {
  value: AnalyticsPdfOption[];
  onChange: (value: AnalyticsPdfOption[]) => void;
}) => (
  <Fragment>
    <MultiSelectInput
      name={`AnalyticsPDFs`}
      options={analyticsPdfsOptions}
      onChange={onChange}
      value={analyticsPdfsOptions.filter(e => !!(value || [])?.find(el => e?.value === el?.value))}
      loading={false}
      disabled={false}
    />
  </Fragment>
);

export default AnalyticsPdfsMultipleSelectInput;
